import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/workspace/$workspaceId/settings/')({
  beforeLoad: (ctx) => {
    throw redirect({
      to: '/workspace/$workspaceId/settings/general',
      params: {
        workspaceId: ctx.params.workspaceId,
      },
    });
  },
});
